import type { QuoteBlock } from "rivals/shared/interfaces/Content";
import { setData } from "rivals/shared/utils/qa";
import styles from "./QuoteBlock.module.scss";
import { Props } from "./types";

const DATA_PHILTER = "quote-block";

function QuoteBlock({ author, quote }: Props): React.JSX.Element {
  return (
    <div {...setData(DATA_PHILTER)} className={styles.wrapper}>
      <div {...setData(DATA_PHILTER, "quote")} className={styles.quote}>
        {quote}
      </div>
      <div {...setData(DATA_PHILTER, "author")} className={styles.author}>
        {author}
      </div>
    </div>
  );
}
export default QuoteBlock;
